import { TranslationEntry } from '../types';

export const en: TranslationEntry = {
  menu: 'Menu',
  chooseLanguage: 'Choose Language',
  english: 'English',
  spanish: 'Spanish',
  searchByArea: 'Search by area',
  searchByCity: 'Search by City',
  searchPlaceholder: "Search...",
  searchChiapasPlaceholder: "Search cities in Chiapas...",
  searchHidalgoPlaceholder: "Search cities in Hidalgo...",
  searchSpecialRegionsPlaceholder: "Search cities...",
  quickSelect: 'Quick Select Region',
  selectRegion: 'Select a region',
  fundingPercentage: 'Funding Percentage',
  filterByPresence: 'Filter by Christian Presence',
  filterByFunding: 'Filter by Funding',
  all: 'All',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  unreached: 'Unreached',
  resetFilters: 'Reset Filters',
  noResults: 'No Results',
  regions: 'Regions',
  backToRegion: 'Back to Region',
  backToCountry: 'Back to Country',
  pledged: 'Pledged',
  donationSuccessful: 'Pledge Successful!',
  donationSuccessMessage: 'Thank you for your pledge to the {region} region!',
  donationSuccessGeneric: 'Thank you for your pledge!',
  donationCanceled: 'Pledge Canceled',
  donationCanceledMessage: 'Your pledge has been canceled.',
  churchesInRegion: 'Churches in {region}',
  missionaryTeam: 'Missionary Team',
  churchDetails: 'Church Details',
  cityDetails: 'City Details',
  regionDetails: 'Region Details',
  cities: 'Cities',
  
  // Christian presence labels
  lessThan5Percent: 'Less than 5% Christian presence',
  lessThan10Percent: 'Less than 10% Christian presence',
  lessThan30Percent: 'Less than 30% Christian presence',
  moreThan30Percent: 'More than 30% Christian presence',
  
  // Region info labels
  regionInfo: 'Region Info',
  churches: 'Churches',
  donate: 'Make a Donation',
  churchPresence: 'Church Presence',
  fundingProgress: 'Funding Progress',
  missionaries: 'Missionaries',
  languages: 'Languages',
  of: 'of',
  funded: 'Funded',
  
  // Stats and other labels
  unreachedPeoples: 'Unreached Peoples',
  show: 'Show',
  hide: 'Hide',
  estimatedUnreachedPopulation: 'Estimated Unreached Population',
  joshuaProjectData: 'Data sourced from Joshua Project',
  population: 'Population',
  evangelicalPercentage: 'Evangelical %',
  primaryReligion: 'Primary Religion',
  primaryLanguage: 'Primary Language',
  citiesInRegion: 'Cities in Region',
  
  // City info labels
  cityStats: 'City Stats',
  unknown: 'Unknown',
  unreachedPercentage: 'Unreached %',
  about: 'About',
  target: 'Target',
  prayerNeeds: 'Prayer Needs',
  prayerForMissionaries: 'Pray for more missionaries',
  prayerForChurches: 'Pray for church planting efforts',
  prayerForFunding: 'Pray for funding to be secured',
  prayerForOutreach: 'Pray for effective outreach programs',
  pledgeSupport: 'Pledge Support',
  learnMore: 'Learn More',
  
  // New Chiapas heatmap translations
  chiapasHeatmapTitle: "Church Presence Heatmap",
  chiapasHeatmapDescription: "Now showing the church presence heatmap for Chiapas region. Cities are colored by their level of church presence.",
  churchPresenceFilters: "Church Presence Filters",
  
  // Hidalgo-specific translations
  hidalgoFilters: "Hidalgo Filters",
  hidalgoHeatmapTitle: "Hidalgo Region",
  hidalgoHeatmapDescription: "Showing church presence heatmap for Hidalgo region with indigenous Otomí communities",
  
  // Filter and navbar
  filters: "Filters",
  search: "Search",
  specialRegionsOnly: "Chiapas & Hidalgo only",
  
  // New translations for search functionality
  makeDonation: "Make a Donation",
  name: "Name",
  enterName: "Enter your name",
  email: "Email",
  enterEmail: "Enter your email",
  donationAmount: "Donation Amount",
  cancel: "Cancel",
  processing: "Processing...",
  donationError: "Donation Error",
  pleaseTryAgain: "Please try again",
  
  // New translations for region and city cards
  adoptThisRegion: "Adopt this Region",
  cityInformation: "City Information",
  peopleGroups: "People Groups",
  pledgedInRegion: "pledged in region",
  resetView: "Reset View",
  
  // New translations for funding and pledges
  applyForFunding: 'Apply for Funding',
  fundingDescription: 'Submit your mission project for funding consideration',
  fundingRequirements: 'Requirements',
  validProject: 'Valid mission project proposal',
  detailedBudget: 'Detailed budget breakdown',
  timelineRequired: 'Project timeline',
  impactMetrics: 'Impact measurement plan',
  startApplication: 'Start Application',
  pledgeDescription: 'Support mission work in this city',
  cityName: 'City',
  makePledge: 'Make a Pledge',
  
  'legend': 'Key'
};
